import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Select' },
    { value: 2, label: 'Multiple Select' },
    { value: 3, label: 'Numeric' },
    { value: 4, label: 'Icon Select' },
  ],
});
